export class ClearUsers {
    public static type = "[Users] Clear users";
}
